module.exports = __webpack_public_path__ + "static/media/worker_white.10cefb53.svg";